import { createSelector } from 'reselect';

const selectWalletPayment = (state) => state.walletPayment;

const selectTransactionId = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.transactionId
);

const selectAmount = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.amount
);

const selectBarcode = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.barcode
);

const walletTransactionList = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.transactionList.data
);

const totalTransactionList = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.transactionList.total_entries
);

const selectBarcodeError = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.error
);

const selectBarcodeStatus = createSelector(
	selectWalletPayment,
	(walletPayment) => walletPayment?.status
);

const walletPaymentSelectors = {
	selectTransactionId,
	selectBarcode,
	selectAmount,
	selectBarcodeError,
	walletTransactionList,
	totalTransactionList,
	selectBarcodeStatus,
};

export default walletPaymentSelectors;
